export enum Authenticator {
    INTERNAL = 'INTERNAL',
    PRESHARED = 'PRESHARED',
    CERTIFICATE = 'CERTIFICATE',
    LICENSE = 'LICENSE',
    SSO_FEDERATED = 'SSO_FEDERATED',
    SSO_STATEFARM = 'SSO_STATEFARM',
    SSO_SAIR = 'SSO_SAIR',
}
